import { Component } from '@angular/core';

@Component({
    selector: 'app-sous-titre-bloc',
    templateUrl: './sous-titre-bloc.component.html',
    styleUrls: ['./sous-titre-bloc.component.scss']
})
export class SousTitreBlocComponent {

}
